// src/components/TrustPilotBanner/index.jsx
import React from 'react';
import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Avatar,
  Stack,
} from '@mui/material';
import person1 from './person1.png';
import person2 from './person2.png';
import person3 from './person3.png';
import ratings from './trustpilot-ratings.svg';
import logo from './trustpilot-logo.svg';

const TrustPilotBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const avatars = [person1, person2, person3];

  return (
    <Box
      component="section"
      sx={{
        p: 2,
        maxWidth: 600,
        mx: 'auto',
      }}
    >
      {isMobile ? (
        <Stack spacing={1} alignItems="center">
          <Box display="flex" alignItems="center">
            <Typography
              sx={{
                color: 'rgb(49, 60, 79)',
                fontSize: '16px',
                fontWeight: 700,
              }}
            >
              Excellent
            </Typography>
            <Box
              component="img"
              src={ratings}
              alt="Trustpilot ratings"
              sx={{ height: 16, ml: 1 }}
            />
            <Box
              component="img"
              src={logo}
              alt="Trustpilot logo"
              sx={{ height: 30, ml: 3 }}
            />
          </Box>

          <Typography
            sx={{ color: 'rgb(49, 60, 79)', fontSize: '16px', fontWeight: 500 }}
          >
            4.5 based on 1,000+ reviews
          </Typography>

          {/* Avatares */}
          <Box display="flex" alignItems="center">
            {avatars.map((src, i) => (
              <Avatar
                key={i}
                src={src}
                sx={{
                  width: 32,
                  height: 32,
                  border: '2px solid white',
                  ml: i === 0 ? 0 : -1,
                }}
              />
            ))}
          </Box>
        </Stack>
      ) : (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={2}
        >
          <Grid item>
            {' '}
            <Box display="flex" alignItems="center">
              {avatars.map((src, i) => (
                <Avatar
                  key={i}
                  src={src}
                  sx={{
                    width: 40,
                    height: 40,
                    border: '2px solid white',
                    ml: i === 0 ? 0 : -1,
                  }}
                />
              ))}
              <Typography
                sx={{
                  color: 'rgb(49, 60, 79)',
                  fontSize: '16px',
                  fontWeight: 700,
                  ml: 2,
                }}
              >
                Excellent
              </Typography>
              <Box
                component="img"
                src={ratings}
                alt="Trustpilot ratings"
                sx={{ height: 20, ml: 1 }}
              />
            </Box>
          </Grid>

          {/* Right block */}
          <Grid item>
            <Box display="flex" alignItems="center">
              <Typography
                sx={{
                  color: 'rgb(49, 60, 79)',
                  fontSize: '16px',
                  fontWeight: 500,
                }}
              >
                4.5 based on 1,000+ reviews
              </Typography>
              <Box
                component="img"
                src={logo}
                alt="Trustpilot logo"
                sx={{ height: 30, ml: 3 }}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default TrustPilotBanner;
